export default __webpack_public_path__ + "static/media/b39.e2f1c1c8.png";